import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon from './Icon';
import { clearLoginAlert } from '../../actions/appUserAuth';

// Login-scoped alert banner (styled with the .p-login design tokens). Driven
// by appUserAuth.alert - the login sagas set friendly, on-brand messages here
// for connection/server failures instead of the raw "Failed to fetch" toast.
const LoginAlert = () => {
  const dispatch = useDispatch();
  const alert = useSelector(state => state.appUserAuth.alert);

  if (!alert) return null;

  const kind = alert.kind || 'error';
  const ICONS = { success: 'shield-check', info: 'info', error: 'alert-circle' };
  const iconName = ICONS[kind] || 'alert-circle';

  return (
    <div className={`p-login__alert p-login__alert--${kind}`} role="alert">
      <Icon name={iconName} size={18} />
      <span className="p-login__alert-msg">{alert.message}</span>
      <button
        type="button"
        className="p-login__alert-close"
        aria-label="Cerrar"
        onClick={() => dispatch(clearLoginAlert())}
      >
        <Icon name="x" size={16} />
      </button>
    </div>
  );
};

export default LoginAlert;
